/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*********************!*\
  !*** ./src/view.js ***!
  \*********************/
/* eslint-disable no-console */
//console.log( 'Hello World! (from exe-post-dynamic-related-content block)' );
/* eslint-enable no-console */

document.addEventListener('DOMContentLoaded', function () {
  checkBlog();
  checkJob();
  var submitButton = document.getElementsByClassName("wp-exe-contact-form-submit-button")[0];
  submitButton.addEventListener("click", function () {
    var fullName = document.getElementsByName("full_name")[0].value;
    var email = document.getElementsByName("email")[0].value;
    var phone = document.getElementsByName("tel")[0].value;
    var motivation = document.getElementsByName("text")[0].value;
    var requestData = {
      full_name: fullName,
      email: email,
      phone: phone,
      text: motivation
    };
    function markInvalidElement(element) {
      element.classList.add("invalid");
      setTimeout(function () {
        resetElementClass(element);
      }, 1000);
      function resetElementClass(element) {
        element.classList.remove("invalid");
      }
    }
    function isValid(fullName, email, text) {
      var result = {
        all_valid: true,
        name_valid: true,
        email_valid: true,
        text_valid: true
      };
      if (!fullName) {
        result.name_valid = false;
        result.all_valid = false;
      }
      emRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emRegex.test(email)) {
        result.email_valid = false;
        result.all_valid = false;
      }
      if (!text) {
        result.text_valid = false;
        result.all_valid = false;
      }
      return result;
    }
    var valid = isValid(fullName, email, motivation);
    if (valid.all_valid) {
      fetchHTTPData("/wp-admin/admin-ajax.php?action=exe_apply_job_form_plugin_send_mail&nonce=" + applyJobNonce, requestData).then(data => {
        if (typeof data === "object") {
          console.log(data);
          if (data.mail_sent == true) {
            playSuccessMessage();
          } else {
            if (!data.valid.name) {
              markInvalidElement(document.getElementsByName("full_name")[0]);
            }
            if (!data.valid.email) {
              markInvalidElement(document.getElementsByName("email")[0]);
            }
            if (!data.valid.text) {
              markInvalidElement(document.getElementsByName("text")[0]);
            }
          }
        } else {
          alert("Error, server status code: " + data);
        }
      });
    } else {
      if (!valid.name_valid) {
        markInvalidElement(document.getElementsByName("full_name")[0]);
      }
      if (!valid.email_valid) {
        markInvalidElement(document.getElementsByName("email")[0]);
      }
      if (!valid.text_valid) {
        markInvalidElement(document.getElementsByName("text")[0]);
      }
    }
  });
  var motivationTextarea = document.getElementsByName("text")[0];
  motivationTextarea.addEventListener("input", function () {
    const lineCount = (motivationTextarea.value.match(/\n/g) || []).length + 1;
    const lineHeight = getLineHeight(motivationTextarea);
    motivationTextarea.style.height = 'auto';
    motivationTextarea.style.height = lineCount * lineHeight + 'px';
  });
});

function checkBlog() {
  fetchHTTPData("/wp-admin/admin-ajax.php?action=exe_is_blog_post", {
    parent_category_id: 19
  }).then(data => {
    if (data.is_blog) {
      const dateBlock = document.getElementsByClassName("exe-post-date")[0];
      dateBlock.style.display="block";
    }
  });
}
function checkJob() {
  fetchHTTPData("/wp-admin/admin-ajax.php?action=exe_apply_job_form_plugin_get_job_info", {
    parent_category_id: 15
  }).then(data => {
    if (data.is_job) {
      const pluginBlock = document.getElementsByClassName("wp-block-exe-post-dynamic-related-content")[0];
      pluginBlock.classList.add("shown");
    }
  });
}
async function fetchHTTPData(url, data) {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  });
  if (!response.ok) {
    const error = data && data.message || response.status;
    return error;
  }
  return response.json();
}
function clearFields() {
  document.getElementsByName("full_name")[0].value = "";
  document.getElementsByName("email")[0].value = "";
  document.getElementsByName("tel")[0].value = "";
  document.getElementsByName("text")[0].value = "";
}
function playSuccessMessage() {
  document.getElementsByClassName("exe-success-mail-message-block")[0].classList.remove("hidden");
  /*
  setTimeout(removeForm, 1500);
  function removeForm(){
  	
  }
  
  function fadeOutMessage(){
  	clearFields();
  	document.getElementsByClassName("exe-success-mail-message-block")[0].classList.add("faded");
  	setTimeout(resetMessage, 500);
  }
  function resetMessage(){
  	document.getElementsByClassName("exe-success-mail-message-block")[0].classList.remove("faded");
  	document.getElementsByClassName("exe-success-mail-message-block")[0].classList.add("hidden");
  }
  */
}
function getLineHeight(element) {
  const tempElement = document.createElement('div');
  tempElement.innerHTML = 'dummy'; // A single word to calculate line height
  tempElement.style.fontFamily = getComputedStyle(element).fontFamily;
  tempElement.style.fontSize = getComputedStyle(element).fontSize;
  tempElement.style.lineHeight = getComputedStyle(element).lineHeight;
  tempElement.style.visibility = 'hidden';
  document.body.appendChild(tempElement);
  const height = tempElement.clientHeight;
  document.body.removeChild(tempElement);
  return height;
}
/******/ })()
;